/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */

import React, {
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Widget } from '@typeform/embed-react';

import { analyticService } from 'global/services';
import { LocaleContext } from 'app/containers/LocaleProvider';
import { Mobile, Desktop } from 'app/components/Responsive';

import Checkbox, { VERSION_UIKIT } from 'app/components/Form/Checkbox2';

import { isDesktop } from 'app/utils/resolution';
import { ConfigContext } from '../ConfigProvider';

import DishDetailsInnerBlock from './DishDetailsInnerBlock';
import { DishMediaContent } from '../Dish/DishMediaContent';
import DishDetailsImage from './DishDetailsImage';
import DishDetailsSubtitle from './DishDetailsSubtitle';
import DishDetailsTable from './DishDetailsTable';
import DishDetailsTextContent from './DishDetailsTextContent';
import DishDetailsHowMuch from './DishDetailsHowMuch';
import DishDetailsHowLong from './DishDetailsHowLong';
import { DishDetailsCounter } from './DishDetailsCounter';

import { DishButton } from '../DishButtons';

import clockSrc from '../../../assets/images/clock.svg';

// HALLOWEEN IMAGES
import halloweenCookieS from '../../../pages/halloween/img/menu/cookie-s.jpg';
import halloweenCookieL from '../../../pages/halloween/img/menu/cookie-l.jpg';
import halloweenChocoCookiesS from '../../../pages/halloween/img/menu/choko-cookies-s.jpg';
import halloweenChocoCookiesL from '../../../pages/halloween/img/menu/choko-cookies-l.jpg';
import halloweenPizzaS from '../../../pages/halloween/img/menu/pizza-s.jpg';
import halloweenPizzaL from '../../../pages/halloween/img/menu/pizza-l.jpg';
import halloweenPunchS from '../../../pages/halloween/img/menu/punch-s.jpg';
import halloweenPunchL from '../../../pages/halloween/img/menu/punch-l.jpg';

import './dish-details.scss';
import { NYGiftContext } from '../NYGiftContext';
import { isHalloweenPages } from '../OrderDetails/OrderDetailsBoxes/components/BoxesCheckForm';


const locales = {
    ru: {
        weightTitle: 'Сколько получится?',
        timeTitle: 'Сколько готовить?',
        whatsInside: 'Что в наборе?',
    },
    en: {
        weightTitle: 'Weight',
        timeTitle: 'Cooking time',
        whatsInside: 'What\'s inside a mealkit?',
    },
};


const fixedButtonDishIds = [2042, 173, 364, 172];
const halloweenBoxDishes = [4689, 4688, 4693, 3828];

const halloweenImagesRecord = {
    4689: {
        s: halloweenCookieS,
        l: halloweenCookieL,
    },
    4688: {
        s: halloweenChocoCookiesS,
        l: halloweenChocoCookiesL,
    },
    4693: {
        s: halloweenPizzaS,
        l: halloweenPizzaL,
    },
    3828: {
        s: halloweenPunchS,
        l: halloweenPunchL,
    },
};

const giftWrapPriceRecord = {
    gingerbread: '+ 100 ₽',
    cantucci: '- 100 ₽',
};

const DishAddToCartButtonWithGift = (props) => {
    const {
        giftWrapId,
        hasStaticPositon = false,
        buttonsDisabled,
        onClickAddToBasket,
        portionButtonProps,
    } = props;

    const {
        getItemsListById,
    } = useContext(NYGiftContext);

    const {
        isGiftItemSelected,
        setIsGiftItemSelected,
        name,
    } = getItemsListById(giftWrapId);

    const giftWrapPrice = useMemo(() => giftWrapPriceRecord[name], [name]);

    return (
        <div styleName="gift-button-wrapper-root">
            <div styleName="gift-button-card">
                <div styleName="gift-button-wrapper-flex">
                    <div styleName="gift-button-handler-area">
                        <div styleName="gift-button-handler-title">
                            Подарочная упаковка
                        </div>
                        <div styleName="gift-button-handler-dots gift-with--dots" />
                        <div styleName="gift-button-handler-price">
                            {giftWrapPrice}
                        </div>
                        <div styleName="gift-button-handler-checkbox">
                            <Checkbox
                                version={VERSION_UIKIT}
                                name="gift-wrap"
                                id="gift-wrap"
                                onChange={() => { setIsGiftItemSelected(!isGiftItemSelected); }}
                                checked={isGiftItemSelected}
                                ariaLabel="Бесконтактная доставка"
                            />

                        </div>
                    </div>
                    <div styleName="gift-button-button-area">
                        <DishButton
                            {...portionButtonProps}
                            onClickAddToBasket={onClickAddToBasket}
                            buttonsDisabled={buttonsDisabled}
                            hasStaticPositon={hasStaticPositon}
                            giftWrapId={giftWrapId}
                            realm="DISH_DETAILS"
                            isChecked={isGiftItemSelected}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};


const HwlwDishContent = (props) => {
    const {
        howMuchTitle, detailContent, timeTitle, howLong, time, timeText,
        whatsInside, table,
    } = props;

    return (
        <div styleName="ny__dish-details__left-side">
            <DishDetailsInnerBlock type="content">
                <DishDetailsTextContent content={detailContent.content} />
            </DishDetailsInnerBlock>

            {(!table && detailContent.composition) && (
                <DishDetailsInnerBlock type="howMuch">
                    <DishDetailsSubtitle>
                        {whatsInside}
                    </DishDetailsSubtitle>
                    <p className="ny__dishes-details__content paragraph">
                        <br />
                        {detailContent.composition}
                    </p>
                </DishDetailsInnerBlock>
            )}
            <DishDetailsInnerBlock type="howMuch">
                <DishDetailsSubtitle>
                    {howMuchTitle}
                </DishDetailsSubtitle>
                <DishDetailsHowMuch
                    // howMuch={howMuch}
                    // weight={weight}
                    weightText={detailContent.hlwn_howMuch}
                />
            </DishDetailsInnerBlock>
            <DishDetailsInnerBlock type="howMuch">
                <DishDetailsSubtitle>
                    {timeTitle}
                </DishDetailsSubtitle>
                <DishDetailsHowLong
                    howLong={howLong}
                    time={time}
                    timeText={timeText}
                />
            </DishDetailsInnerBlock>
        </div>
    );
};

export default function DishDetails({
    isActive,
    isEntered,
    dish,
    portionButtonProps,
    index,
    canChangePortionsCount = false,
    fillHeight,
    setRef = () => { },
}) {
    const { locale } = useContext(LocaleContext);
    const {
        pageId,
        isNutritionEnabled,
    } = useContext(ConfigContext);

    const containerRef = useRef(null);
    useEffect(() => {
        setRef(containerRef.current);
    }, [setRef]);

    const {
        category,
        id,
        price,
        imageUrl,
        imageUrlDesktopDetails,
        imageUrlMobileDetails,
        alt,
        detailContent,
        title: titleArrRu,
        titleEn: titleArrEn,
        weight,
        weightText: weightTextRu,
        weightTextEn,
        weightValue,
        time,
        timeText: timeTextRu,
        timeTextEn,
        isTimeHidden,
        hour,
        hourText,
        minutes,
        minutesText,
        isSoldOut,
        typeformWidgetId,
        buttonTextAction,
        nutrition,
        slides,
        giftWrapId,
    } = dish;

    const isHalloweenBoxDish = halloweenBoxDishes.includes(Number(id));
    const currentImageUrlS = isHalloweenBoxDish
        ? halloweenImagesRecord[id].s
        : (imageUrlMobileDetails || imageUrl);
    const currentImageUrlL = isHalloweenBoxDish ? halloweenImagesRecord[id].l : imageUrlDesktopDetails;

    const titles = {
        ru: titleArrRu,
        en: titleArrEn,
    };
    const titleArr = titles[locale];
    const weights = {
        ru: weightTextRu,
        en: weightTextEn,
    };
    const weightText = weights[locale];
    const timeTexts = {
        ru: timeTextRu,
        en: timeTextEn,
    };
    const timeText = timeTexts[locale];

    const { portion } = portionButtonProps;

    const handleAddToBasket = ({ portions }) => {
        analyticService.push({
            eventName: 'add_to_cart',
            dishes: [{
                id,
                title: titleArr.join(' '),
                caption: '',
                price,
                portion: portions,
                categoryId: category,
            }],
            source: pageId,
            subscriptionType: 'singlePay',
        });
    };

    useEffect(() => {
        if (!isActive || !isEntered) return;

        analyticService.push({
            title: titleArr.join(' '),
            caption: '',
            price,
            categoryId: category,
            id,
            source: pageId,
            eventName: 'Dish_Details_Viewed',
        }).push({
            id,
            eventName: 'CityAds_Dish_Details_Viewed',
        });
    }, [category, id, isActive, isEntered, price, titleArr, pageId]);

    const dishTitleMobile = titleArr.join('<br>');
    const dishTitleDesktop = titleArr.join(' ');

    const hasCookInfo = detailContent.hasCookInfo === undefined
        ? weight || time
        : (weight || time) && detailContent.hasCookInfo;

    const portionsButtonWrapperClasses = classNames({
        'ny__dish-details-portions-button-wrap': true,
        fixed: fixedButtonDishIds.includes(Number(id)),
    });

    const titleClasses = classNames({
        'ny__dish-details__title-content__container': true,
        halloween: isHalloweenBoxDish,
    });

    const content = locale === 'en' ? detailContent.contentEn : detailContent.content;
    const table = locale === 'en' ? detailContent.tableEn : detailContent.table;
    const howMuch = locale === 'en' ? detailContent.howMuchEn : detailContent.howMuch;
    const howLong = locale === 'en' ? detailContent.howLongEn : detailContent.howLong;

    // в категории sauces - буква "С" из русского алфавита. Приходит в таком виде
    const hasHowMuch = category === 'sauсes' ? false : Boolean(howMuch || weight);
    const hasHowLong = Boolean(howLong || time);

    const howMuchTitle = detailContent.howMuchTitleRu || locales[locale].weightTitle;

    const hasContent = (() => {
        if (Array.isArray(content)) {
            if (content.length === 0) return false;
            return Boolean(content[0].text);
        }
        return Boolean(content);
    })();

    const hasButton = !isSoldOut && canChangePortionsCount && buttonTextAction !== 'openDetails';

    const nutritionTable = isNutritionEnabled && nutrition ? [
        {
            generalTitle: 'На 1 готовую порцию',
            list: [
                {
                    name: 'Масса',
                    amount: weightValue,
                    unit: 'г',
                },
                {
                    name: ' Калорийность',
                    amount: Math.round((nutrition.calories.value * weightValue) / 100),
                    unit: 'ккал',
                },
                {
                    name: 'Белки',
                    amount: Math.round((nutrition.protein.value * weightValue) / 100),
                    unit: 'г',
                },
                {
                    name: 'Жиры',
                    amount: Math.round((nutrition.fat.value * weightValue) / 100),
                    unit: 'г',
                },
                {
                    name: 'Углеводы',
                    amount: Math.round((nutrition.carbohydrate.value * weightValue) / 100),
                    unit: 'г',
                },
            ],
        },
    ] : [];

    const rootClasses = classNames({
        'ny__dish-details__root': true,
        'ny__dish-details__root--fill-height': fillHeight,
    });

    const detailsSlides = slides.filter((s) => s.placement !== 'card');

    const {
        isGiftItem,
        getItemsListById,
    } = useContext(NYGiftContext);

    // eslint-disable-next-line camelcase
    const portionsCountWith_gift_dish = useMemo(() => {
        if (isGiftItem(id)) {
            const { itemsList } = getItemsListById(id);
            return itemsList.length;
        }
        return portion;
    }, [portion, getItemsListById, id, isGiftItem]);

    // const is = isDesktop();

    const isNeedToShowCounterForFiftWrap = !isDesktop() && isGiftItem(id);

    const isHlwnPage = isHalloweenPages(pageId);

    return (
        <div styleName={rootClasses} data-list-index={index} ref={containerRef}>
            {/* СЛАЙДЕР */}
            {detailsSlides && detailsSlides.length ? (
                <DishMediaContent
                    context="details"
                    useLazyLoading={false}
                    id={id}
                    alt={alt}
                    imageUrl={currentImageUrlS}
                    imageUrlDesktop={currentImageUrlL}
                    slides={detailsSlides}
                    additionalContent={(
                        // eslint-disable-next-line react/jsx-no-useless-fragment
                        <>
                            {
                                isNeedToShowCounterForFiftWrap
                                // eslint-disable-next-line camelcase
                                && <DishDetailsCounter portion={portionsCountWith_gift_dish} />}

                        </>
                    )}
                />
            ) : (
                <DishDetailsImage
                    id={id}
                    alt={alt}
                    imageUrl={currentImageUrlS}
                    imageUrlDesktop={currentImageUrlL}
                    portion={portion}
                    canChangePortionsCount={canChangePortionsCount}
                />
            )}

            <Mobile>
                <DishDetailsInnerBlock type="h2">
                    <div styleName="ny__dish-details__title-content__container">
                        <DishDetailsSubtitle>
                            {dishTitleMobile}
                        </DishDetailsSubtitle>
                    </div>
                    {/* FRNT-3400 NY2024 КОСТЫЛЬ ПОДАРОЧНАЯ УПАКОВКА MOBILE */}
                    {giftWrapId
                        && (
                            <DishAddToCartButtonWithGift
                                portionButtonProps={portionButtonProps}
                                onClickAddToBasket={handleAddToBasket}
                                buttonsDisabled={isSoldOut}
                                hasStaticPositon
                                giftWrapId={giftWrapId}
                            />
                        )}
                </DishDetailsInnerBlock>
            </Mobile>

            <Desktop>
                <DishDetailsInnerBlock type={hasButton ? '' : 'h2'}>
                    <div styleName={titleClasses}>
                        {/* {giftWrapId && <div styleName="gift-button-wrapper-indent-modifier" />} */}
                        <DishDetailsSubtitle giftWrapId={giftWrapId}>
                            {dishTitleDesktop}
                        </DishDetailsSubtitle>
                        <div styleName={portionsButtonWrapperClasses}>
                            {/* FRNT-3400 NY2024 КОСТЫЛЬ ПОДАРОЧНАЯ УПАКОВКА DESKTOP */}
                            {!isHalloweenBoxDish && (
                                <div>
                                    {hasButton && (
                                        !giftWrapId ? (
                                            <DishButton
                                                {...portionButtonProps}
                                                onClickAddToBasket={handleAddToBasket}
                                                buttonsDisabled={isSoldOut}
                                                hasStaticPositon
                                                giftWrapId={giftWrapId}
                                            />
                                        )
                                            : (
                                                <DishAddToCartButtonWithGift
                                                    portionButtonProps={portionButtonProps}
                                                    onClickAddToBasket={handleAddToBasket}
                                                    buttonsDisabled={isSoldOut}
                                                    hasStaticPositon
                                                    giftWrapId={giftWrapId}
                                                />
                                            )
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </DishDetailsInnerBlock>
            </Desktop>

            <div styleName="ny__dish-details__separator" />

            {/*  МОБИЛЬНАЯ КНОПКА ADD TO BASKET */}
            {!isHalloweenBoxDish && hasButton && !giftWrapId && (
                <Mobile>
                    <DishDetailsInnerBlock type="h2">
                        <DishButton
                            {...portionButtonProps}
                            onClickAddToBasket={handleAddToBasket}
                            giftWrapId={giftWrapId}
                        />
                    </DishDetailsInnerBlock>
                    <div styleName="ny__dish-details__separator" />
                </Mobile>
            )}

            {(hasCookInfo && !typeformWidgetId) ? (
                <Desktop>
                    <div className="ny__dish__info-container small">
                        <img
                            src={clockSrc}
                            alt="часы картинка"
                            className="ny__dish__clock-img"
                        />
                        {weight ? (
                            <span className="ny__dish__weight">
                                <span className="num">{weight}</span>
                                &nbsp;
                                {weightText}
                            </span>
                        ) : null}
                        {!isTimeHidden && time ? (
                            <span className="ny__dish__cooking-time">
                                <span className="num">{time}</span>
                                &nbsp;
                                {timeText}
                            </span>
                        ) : null}
                        {!isTimeHidden && (hour || minutes) ? (
                            <>
                                <span className="ny__dish__cooking-time">
                                    {hour !== ' ' && (
                                        <>
                                            <span className="num">{hour}</span>
                                            &nbsp;
                                        </>
                                    )}
                                    {hourText}
                                    &nbsp;
                                </span>

                                <span className="ny__dish__cooking-time">
                                    {minutes !== ' ' && (
                                        <>
                                            <span className="num">{minutes}</span>
                                            &nbsp;
                                        </>
                                    )}
                                    {minutesText}
                                </span>
                            </>
                        ) : null}
                    </div>
                    <div styleName="ny__dish-details__separator" />
                </Desktop>
            ) : null}

            <div styleName="ny__dish-details__content-root">
                {isHlwnPage ? (
                    <HwlwDishContent
                        howMuchTitle={howMuchTitle}
                        detailContent={detailContent}
                        timeTitle={locales[locale].timeTitle}
                        howLong={howLong}
                        time={time}
                        timeText={timeText}
                        whatsInside={locales[locale].whatsInside}
                        table={table}
                    />
                )
                    : (
                        <>
                            <div styleName="ny__dish-details__left-side">
                                {hasContent && !typeformWidgetId && (
                                    <DishDetailsInnerBlock type="content">
                                        <DishDetailsTextContent
                                            content={content}
                                        />
                                        {category === 'sauсes' && (
                                            <DishDetailsTextContent
                                                content={[{ text: detailContent.composition }]}
                                            />
                                        )}
                                    </DishDetailsInnerBlock>
                                )}
                                {typeformWidgetId && (
                                    <DishDetailsInnerBlock type="content">
                                        <Widget
                                            source="elementaree1"
                                            id={typeformWidgetId}
                                            style={{ height: '500px' }}
                                            styleName="ny__dish-details__typeform-widget"
                                        />
                                    </DishDetailsInnerBlock>
                                )}
                                {!typeformWidgetId && (
                                    <Desktop>
                                        {detailContent.hard && (
                                            <DishDetailsInnerBlock type="howMuch">
                                                <DishDetailsSubtitle small>
                                                    Сложность рецепта
                                                </DishDetailsSubtitle>
                                                <div dangerouslySetInnerHTML={{ __html: detailContent.hard }} />
                                            </DishDetailsInnerBlock>
                                        )}
                                        {hasHowMuch && (
                                            <DishDetailsInnerBlock type="howMuch">
                                                <DishDetailsSubtitle small>
                                                    {howMuchTitle}
                                                </DishDetailsSubtitle>
                                                <DishDetailsHowMuch
                                                    howMuch={howMuch}
                                                    weight={weight}
                                                    weightText={weightText}
                                                />
                                            </DishDetailsInnerBlock>
                                        )}
                                        {hasHowLong && (
                                            <DishDetailsInnerBlock type="howMuch">
                                                <DishDetailsSubtitle small>
                                                    {locales[locale].timeTitle}
                                                </DishDetailsSubtitle>
                                                <DishDetailsHowLong
                                                    howLong={howLong}
                                                    time={time}
                                                    timeText={timeText}
                                                />
                                            </DishDetailsInnerBlock>
                                        )}
                                    </Desktop>
                                )}
                            </div>

                            {table && (
                                <DishDetailsInnerBlock type="table">
                                    <DishDetailsTable table={table} />
                                </DishDetailsInnerBlock>
                            )}
                            {isNutritionEnabled && nutrition && (
                                <DishDetailsInnerBlock type="table">
                                    <DishDetailsTable table={nutritionTable} />
                                </DishDetailsInnerBlock>
                            )}
                            {(!table && category !== 'sauсes' && detailContent.composition && id !== '3980') && (
                                <DishDetailsInnerBlock type="howMuch">
                                    <DishDetailsSubtitle>
                                        {locales[locale].whatsInside}
                                    </DishDetailsSubtitle>
                                    <p className="ny__dishes-details__content paragraph">
                                        <br />
                                        {detailContent.composition}
                                    </p>
                                </DishDetailsInnerBlock>
                            )}
                            {!typeformWidgetId && (
                                <Mobile>
                                    {detailContent.hard && (
                                        <DishDetailsInnerBlock type="howMuch">
                                            <DishDetailsSubtitle small>
                                                Сложность рецепта
                                            </DishDetailsSubtitle>
                                            <div dangerouslySetInnerHTML={{ __html: detailContent.hard }} />
                                        </DishDetailsInnerBlock>
                                    )}
                                    {hasHowMuch && (
                                        <DishDetailsInnerBlock type="howMuch">
                                            <DishDetailsSubtitle>
                                                {howMuchTitle}
                                            </DishDetailsSubtitle>
                                            <DishDetailsHowMuch
                                                howMuch={howMuch}
                                                weight={weight}
                                                weightText={weightText}
                                            />
                                        </DishDetailsInnerBlock>
                                    )}

                                    {hasHowLong && (
                                        <DishDetailsInnerBlock type="howMuch">
                                            <DishDetailsSubtitle>
                                                {locales[locale].timeTitle}
                                            </DishDetailsSubtitle>
                                            <DishDetailsHowLong
                                                howLong={howLong}
                                                time={time}
                                                timeText={timeText}
                                            />
                                        </DishDetailsInnerBlock>
                                    )}
                                </Mobile>
                            )}
                        </>
                    )
                }
            </div>

            {/* <Mobile>
                <div styleName={portionsButtonWrapperClasses}>
                    {hasButton && (
                        <DishButton
                            {...portionButtonProps}
                            onClickAddToBasket={handleAddToBasket}
                        />
                    )}
                </div>
            </Mobile> */}
        </div>
    );
}

DishDetails.propTypes = {
    // isActive - элемент находится во вьюпорте слайдера
    isActive: PropTypes.bool.isRequired,
    // isEntered - true, когда закончилась анимация появления слайдера
    isEntered: PropTypes.bool.isRequired,

    canChangePortionsCount: PropTypes.bool,
    dish: PropTypes.shape({
        category: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        alt: PropTypes.string,

        typeformWidgetId: PropTypes.string,
        buttonTextAction: PropTypes.string,

        isSoldOut: PropTypes.bool.isRequired,

        title: PropTypes.arrayOf(PropTypes.string).isRequired,
        titleEn: PropTypes.arrayOf(PropTypes.string).isRequired,

        weight: PropTypes.string,
        weightText: PropTypes.string,
        weightTextEn: PropTypes.string,
        time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        timeText: PropTypes.string,
        timeTextEn: PropTypes.string,

        imageUrl: PropTypes.string.isRequired,
        imageUrlDesktop: PropTypes.string.isRequired,
        imageUrlDesktopDetails: PropTypes.string.isRequired,
        imageUrlMobileDetails: PropTypes.string,

        detailContent: PropTypes.shape({
            hasCookInfo: PropTypes.bool, // ???

            content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
            howMuch: PropTypes.string,
            howLong: PropTypes.string,
            table: PropTypes.arrayOf(PropTypes.shape({
                title: PropTypes.string,
                list: PropTypes.arrayOf(PropTypes.shape({})),
            })),
            howMuchTitleRu: PropTypes.string, // ???

            contentEn: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
            howMuchEn: PropTypes.string,
            howLongEn: PropTypes.string,
            tableEn: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
                title: PropTypes.string,
                list: PropTypes.arrayOf(PropTypes.shape({})),
            }))),

            composition: PropTypes.string,
        }).isRequired,
    }).isRequired,
    index: PropTypes.number.isRequired,
    portionButtonProps: PropTypes.shape({
        portion: PropTypes.number,
    }).isRequired,

    setRef: PropTypes.func,
};
